<template>
  <div class="course-info no-image" v-if="!loading">
    <div class="course-content fadeIn">
      <div class="course-top">
        <i class="icon-i course-cover" :style="{ backgroundImage: 'url(' + course.cover + ')' }"></i>
        <div class="info-box">
          <div class="info-text">课程信息</div>
          <div class="info-title">{{ course.title }}</div>
          <div class="courseprice">
            <span>{{ course.codeCount }}个环节</span>
          </div>
          <a-button class="buy-button" type="primary" size="large" @click="buy()" v-if="!hasJoin">立即激活</a-button>
          <a-button class="buy-button" type="primary" size="large" @click="study()" v-else>进入学习</a-button>
        </div>
      </div>
      <div class="course-menu">
        <div class="menu-title">简介</div>
      </div>
      <div class="course-content ck-editor" v-html="course.Description" v-if="course.Description"></div>
      <div class="empty-box" v-else>
        <img :src="empty_image" alt />
        <div>暂无简介</div>
      </div>

      <div class="other-course-box">
        <div class="other-title">相关课程</div>
        <div class="other-course">
          <div class="course-box">
            <div class="course-item" v-for="course of other_course" @click="chooseCourse(course)">
              <i class="course-cover icon-i" :style="{ backgroundImage: 'url(' + course.cover + ')' }"></i>
              <div class="course-info">
                <a-tooltip placement="topLeft">
                  <template #title>{{ course.title }}</template>
                  <div class="course-title ellipsis">{{ course.title }}</div>
                </a-tooltip>
                <div class="course-subTitle">{{ course.publisher }}</div>
              </div>
            </div>
          </div>
          <div class="other-page other-left" @click="other_list_scroll('left')">
            <svg class="icon-svg">
              <use xlink:href="#icon-last" />
            </svg>
          </div>
          <div class="other-page other-right" @click="other_list_scroll('right')">
            <svg class="icon-svg">
              <use xlink:href="#icon-next" />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import navroot from "@/component/public/nav/nav.vue";
import foot from "@/component/public/foot/foot.vue";
import router from '@/router';

import { LOGINURL, CODEVIEWURL } from '@/config/url';

export default {
  name: 'course-info',
  components: {
    navroot,
    foot
  },
  data() {
    return {
      digitalBookGuid: '',
      classGuid: '',
      empty_image: require('@/assets/images/empty.png'),

      hasBought: false,
      hasJoin: false,
      loading: true,

      course: null,
      user: null,

      digitalBookList: [],
      other_course: [],

      idx: 0,
      num: 7,
      showcouser: true,
      alshow: false,
    }
  },
  mounted() {
    $('#content').animate({ scrollTop: 0 }, 300);
    this.digitalBookGuid = this.$route.params.id;
    const { userInfo, digitalBookList } = this.$store.state;
    this.user = userInfo;
    this.digitalBookList = JSON.parse(JSON.stringify(digitalBookList));
    this.other_course = digitalBookList.filter(item => item.pk_digital_book_id != this.digitalBookGuid);
    this.$store.commit('showReturn', true);

    this.course = digitalBookList.find(item => item.pk_digital_book_id == this.digitalBookGuid);

    if (!this.course) return;
    this.classGuid = this.course.fk_class_id;

    this.loading = false;
    if (this.user) this.findOrder();
  },
  methods: {
    //购买
    buy() {
      if (this.user) return router.push(`/payment/${this.digitalBookGuid}`);
      this.$nzconfirm('需要登录才能购买，是否跳转登录?', () => {
        location.href = `${LOGINURL}?redirectURI=${location.href}`;
      })
    },
    //学习
    study() {
      let { platformUrl } = this.course;
      if (!platformUrl || platformUrl.indexOf('www.lessonplay.cn') > -1) this.$router.push(`/play/${this.digitalBookGuid}`);
      else if (platformUrl.indexOf("lp.lessonplan") > -1) window.open(`${platformUrl}/list/${this.classGuid}?fromType=yuanxi`);
      else window.open(platformUrl)
    },
    //跳转
    chooseCourse(item) {
      window.location.href = `/course-info/${item.pk_digital_book_id}`;
    },
    //判断是否有购买订单或vip是否过期
    async findOrder() {
      let res = await this.$api.payorder.findPayOrder({ fk_goodsGuid: this.digitalBookGuid, fk_userGuid: this.user.PK_UserGuid });
      if (res.statusCode != 200) return this.$message.error(res.error);
      if (res.data && res.data.isPaid) this.hasBought = true;

      if (this.hasBought) return this.isJoin();

      //不是unique_book
      if (this.course.unique_book == 0) {
        let vipList = this.$store.state.studentVip || [];
        let vipInfo = vipList.find(item => item.type == "vip_inner_training");
        if (vipInfo) {
          if (!vipInfo.deadline || new Date() < new Date(vipInfo.deadline)) this.hasBought = true;
          else {
            this.$Modal.confirm({
              okText: '我知道了',
              cancelText: ' ',
              title: `很抱歉，您的VIP已于${moment(vipInfo.deadline).format('YYYY-MM-DD')}过期。请续期VIP或单独购买数字教材使用。`,
              onOk: () => {
                this.$Modal.destroyAll();
              }
            })
          }
        }
      }

      if (this.hasBought) this.isJoin();
    },
    //判断是否加入了班级
    async isJoin() {
      let res = await this.$api.digitalBook.joinList(this.user.PK_UserGuid);
      if (res.status != 1) return this.$message.error(res.message);

      let myclass = res.data.find(item => item.FK_ClassGuid == this.classGuid);
      if (myclass) this.hasJoin = true;
      else this.autoJoinClass();
    },
    //自动加入班级
    async autoJoinClass() {
      let code = this.course.code;
      if (!code) return;
      //加入班级
      let res = await this.$api.unifydata.joinClass({ userGuid: this.user.PK_UserGuid, code , classType: 'textbook'});
      if (res.statusCode != 200) return this.$message.error(res.message);
      this.hasJoin = true;

      //更新列表
      this.digitalBookList.forEach(item => {
        if (item.pk_digital_book_id == this.digitalBookGuid && item.userStatus == 'nojoin') item.userStatus = 'nofinish';
      })
      this.$store.commit("digitalBookList", this.digitalBookList);
    },
    //滚动条移动
    other_list_scroll(type) {
      let scroll = $('.course-box').scrollLeft();
      if (type == 'left') $('.course-box').animate({ scrollLeft: scroll - 800 }, 300)
      else if (type == 'right') $('.course-box').animate({ scrollLeft: scroll + 800 }, 300)
    },
  }
}
</script>

<style scoped lang="scss">
@import "./course-info.scss";
</style>